<script lang="ts" setup>
import helpers from '~/helpers'
import type { SpecialistData } from '~/types/specialists'

const props = defineProps<{
  specialistData: SpecialistData
}>()

const attributes = computed(() => props.specialistData.attributes)
const avatarUrl = computed(() => attributes.value.avatarUrl)
const description = computed(() => attributes.value.description)
const link = computed(() => attributes.value.link)
</script>

<template>
  <div class="specialist-card bg-white">
    <div class="flex">
      <div v-if="avatarUrl" class="specialist-card__avatar">
        <img v-lazy="avatarUrl" :alt="helpers.getFullName(specialistData)" loading="lazy">
      </div>
      <div v-else class="specialist-card__avatar-empty" />

      <div class="specialist-card__info">
        <h3 class="specialist-card__name mb-1">
          {{ helpers.getFullName(specialistData) }}
        </h3>

        <p class="specialist-card__description flex items-center">
          {{ description }}
          <template v-if="link">
            <br><br>{{ link }}
          </template>
        </p>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.specialist-card {
  border-radius: 12px;
  padding: 24px;

  &__avatar, &__avatar-empty {
    border-radius: 50%;
    height: 100px;
    margin-right: 16px;
    width: 100px;

    @media (max-width: 385px) {
      height: 64px;
      width: 64px;
    }
  }

  &__avatar {
    img {
      max-height: 100%;
      max-width: 100%;
    }
  }

  &__avatar-empty {
    background-color: #f1f1f1
  }

  &__description {
    font-size: 16px;
    line-height: 16px;

    @media (max-width: 385px) {
      justify-content: center;
    }
  }

  &__name {
    font-size: 22px;
    font-style: normal;
    font-weight: 500;
    line-height: 1.5em;

    @media (max-width: 580px) {
      font-size: 16px;
    }
  }
}
</style>
